import React from "react";
import Slider from "react-slick";
import useMedia from "react-use/lib/useMedia";
import { User, Badge, mtpBadge } from "@ecologi/shared";
import { AchievementBadge } from "./AchievementBadge";
import badgesRowStyles from "../styles/AchievementRow.module.scss";

export type AchievementBadgeProps = {
  badge: Badge;
  setAchievementPopupBadge?: (badge: Badge) => void;
  user: User | null;
  isStatic?: boolean;
};

const sliderSettings = {
  arrows: false,
  autoplay: false,
  customPaging: () => <button className={badgesRowStyles.sliderDot} />,
  dots: true,
  dotsClass: badgesRowStyles.sliderDots,
  pauseOnHover: false,
  slide: "ul",
};

type BadgesProps = Omit<AchievementBadgeProps, "badge"> & {
  user: User;
  isOwnProfile: boolean;
};

export const AchievementBadges = ({
  user,
  isOwnProfile,
  setAchievementPopupBadge,
}: BadgesProps) => {
  const isMobile = useMedia("(max-width: 768px)");

  let badgeList = user.getTop4Badges();

  if (user.isMtpUser) {
    badgeList = [mtpBadge, ...user.getTop4Badges().slice(0, 3)];
  }

  const badges = badgeList.map((badge) => {
    return (
      <div className={badgesRowStyles.badge} data-large="true" key={badge.id}>
        <AchievementBadge
          key={badge.id}
          user={user}
          badge={badge}
          isStatic={!isOwnProfile}
          setAchievementPopupBadge={setAchievementPopupBadge}
        />
      </div>
    );
  });

  return (
    <>
      {isMobile ? (
        <Slider {...sliderSettings}>{badges}</Slider>
      ) : (
        <div className={badgesRowStyles.badgesWrapper}>{badges}</div>
      )}
    </>
  );
};
